import { Component, computed, input } from '@angular/core';
import { NetzzuordnungenImportSnapshot } from '../../../domain/model/netzzuordnungen-import-snapshot.model';
import { MaterialModule } from '../../../common/material/material.module';

@Component({
    selector: 'redispatch-netzverknuepfungen-list',
    imports: [
        MaterialModule,
    ],
    templateUrl: './netzverknuepfungen-list.component.html',
    styleUrl: './netzverknuepfungen-list.component.scss',
})
export class NetzverknuepfungenListComponent {

    netzzuordungImport = input<NetzzuordnungenImportSnapshot>();

    netzverknuepfungenList = computed(() => this.netzzuordungImport()?.netzverknuepfungen ?? []);

    displayedColumns: string[] = [
        'stadtwerkName',
        'stadtwerkId',
        'countUngueltigeAnlagen',
    ];
}
